
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ServerInterface } from '@/services/Server/Interfaces';

@Component({
  mixins: [Themeable],
})
export default class SyncQuotasDialog extends Vue {
  @Prop() public servers!: ServerInterface;

  public server: string = '';

  public visible: boolean = true;

  public syncQuotas(): void {
    this.$emit('syncQuotas', this.server);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
